import { render, staticRenderFns } from "./CreditTransfer.vue?vue&type=template&id=72f4cc42&scoped=true&"
import script from "./CreditTransfer.vue?vue&type=script&lang=js&"
export * from "./CreditTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CreditTransfer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreditTransfer.vue?vue&type=style&index=1&id=72f4cc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4cc42",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VImg,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f4cc42')) {
      api.createRecord('72f4cc42', component.options)
    } else {
      api.reload('72f4cc42', component.options)
    }
    module.hot.accept("./CreditTransfer.vue?vue&type=template&id=72f4cc42&scoped=true&", function () {
      api.rerender('72f4cc42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/TopUpCredit/components/CreditTransfer.vue"
export default component.exports